import { jsx } from "react/jsx-runtime";
import { useAddressLabel } from "../../../hooks/use-address-label.js";
import { TextInputFieldWUT } from "../../../ui/text-input-field/text-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const MlaAddressLine2WUT = (props) => {
  const fieldType = FIELD_TYPES.MLA_ADDRESS_LINE_2;
  const label = useAddressLabel("addressLine2");
  return /* @__PURE__ */ jsx(TextInputFieldWUT, { ...props, fieldType, label });
};
export {
  MlaAddressLine2WUT
};
//# sourceMappingURL=mla-address-line-2-wut.js.map
